import React from 'react'
import { LayoutRoute } from 'components/Layout';
import { default as HomePublicaLayout } from 'components/Layout/HomePublica';
import { CoberturasCasualityGeneral } from 'containers/Casuality-General/Coberturas';
import { ContratanteCasualityGenerales } from 'containers/Casuality-General/Contratante';
import { InformacionNegocioDatos } from 'containers/Casuality-General/InformacionCliente';
import PagoCasualityGenerales from 'containers/Casuality-General/Pago';
import RecuperarCotizacionCasualityGenerales from 'containers/Casuality-General/RecuperarCotizacion';
import ResumenCasualityGeneral from 'containers/Casuality-General/Resumen';
import { VigenciaCasualityGenerales } from 'containers/Casuality-General/Vigencia';
import { CASUALITY_GENERAL } from 'containers/Casuality-General/constantes';

const CASUALTY_GENERAL_ROUTES = [
  <LayoutRoute
    exact={true}
    path={`${CASUALITY_GENERAL.urls.datosCliente}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={InformacionNegocioDatos}
    navBarTab="personas"
  />,

  <LayoutRoute
    exact={true}
    path={`${CASUALITY_GENERAL.urls.coberturas}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={CoberturasCasualityGeneral}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${CASUALITY_GENERAL.urls.recuperar}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={RecuperarCotizacionCasualityGenerales}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${CASUALITY_GENERAL.urls.resumen}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={ResumenCasualityGeneral}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${CASUALITY_GENERAL.urls.contratante}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={ContratanteCasualityGenerales}
    navBarTab="personas"
  />,
  <LayoutRoute
    exact={true}
    path={`${CASUALITY_GENERAL.urls.pago}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={PagoCasualityGenerales}
    navBarTab="personas"
  />,

  <LayoutRoute
    exact={true}
    path={`${CASUALITY_GENERAL.urls.vigencia}`}
    layout={HomePublicaLayout}
    loginRequired={true}
    component={VigenciaCasualityGenerales}
    navBarTab="personas"
  />,
];

export default CASUALTY_GENERAL_ROUTES;
